import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { Row, Col, Form, Alert } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Component from "@reactions/component";
import { SideSheet, Position, Pane, Dialog, SelectField, Button } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import { Checkbox, FormControlLabel } from '@mui/material/';
import Info from '@material-ui/icons/Info';
import { Link } from 'react-router-dom';
import CategoryIcon from '@material-ui/icons/Category';
import SyncDisabledRounded from '@material-ui/icons/SyncDisabledRounded';
import FileUpload from '@material-ui/icons/SyncRounded';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ListAltIcon from '@material-ui/icons/ListAlt';
import SearchIcon from '@material-ui/icons/Search';
import VisibilityIcon from '@material-ui/icons/Visibility';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";
import Login from '../common/login';

// الأنماط المدمجة
const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f5f7fa',
    fontFamily: "'Cairo', 'Segoe UI', 'Roboto', sans-serif",
    direction: 'rtl',
  },
  header: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '2rem',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    marginBottom: '2rem',
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1400px',
    margin: '0 auto',
  },
  pageTitle: {
    color: '#fff',
    fontSize: '2rem',
    fontWeight: 'bold',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
  addButton: {
    background: '#fff',
    color: '#667eea',
    border: 'none',
    padding: '0.75rem 2rem',
    borderRadius: '50px',
    fontSize: '1rem',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
  },
  searchContainer: {
    maxWidth: '1400px',
    margin: '0 auto 2rem',
    padding: '0 1rem',
  },
  searchBox: {
    background: '#fff',
    borderRadius: '16px',
    padding: '1.5rem',
    boxShadow: '0 2px 15px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
  },
  searchInput: {
    flex: 1,
    padding: '0.75rem 1.5rem',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    fontSize: '1rem',
    outline: 'none',
    transition: 'border-color 0.3s ease',
    fontFamily: 'Cairo, sans-serif',
  },
  searchButton: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff',
    border: 'none',
    padding: '0.75rem 2rem',
    borderRadius: '12px',
    fontSize: '1rem',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  statsCards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem',
    maxWidth: '1400px',
    margin: '0 auto 3rem',
    padding: '0 1rem',
  },
  statCard: {
    background: '#fff',
    borderRadius: '16px',
    padding: '2rem',
    boxShadow: '0 2px 20px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
  },
  tableContainer: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 1rem 2rem',
  },
  modernTable: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    boxShadow: '0 2px 20px rgba(0, 0, 0, 0.05)',
    overflow: 'hidden',
  },
  tableHeader: {
    background: 'linear-gradient(135deg, #f6f9fc 0%, #e9ecef 100%)',
    padding: '1rem 2rem',
    borderBottom: '2px solid #e2e8f0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tableTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#2d3748',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  thead: {
    backgroundColor: '#f8f9fa',
    borderBottom: '2px solid #e2e8f0',
  },
  th: {
    padding: '1.25rem',
    textAlign: 'right',
    fontWeight: '600',
    color: '#4a5568',
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  tbody: {
    backgroundColor: '#fff',
  },
  tr: {
    borderBottom: '1px solid #e2e8f0',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
  },
  td: {
    padding: '1.25rem',
    textAlign: 'right',
    color: '#4a5568',
    fontSize: '0.875rem',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '2rem',
    backgroundColor: '#f8f9fa',
    borderTop: '2px solid #e2e8f0',
  },
  pageButton: {
    padding: '0.5rem 1rem',
    border: '1px solid #e2e8f0',
    backgroundColor: '#fff',
    color: '#4a5568',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '0.875rem',
  },
  activePageButton: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#fff',
    border: 'none',
  },
  emptyState: {
    textAlign: 'center',
    padding: '4rem',
    color: '#718096',
  }
};

const cookies = new Cookies();

class Category extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      filteredOrders: [],
      currentPage: 1,
      itemsPerPage: 10,
      searchTerm: '',
      from: new Date(),
      to: new Date(),
      spin: false,
      serch: false,
      total: '',
      shiper: [],
      company: "",
      totalLists: 0,
      totalDevices: 0,
      pendingLists: 0,
    }
  }

  componentDidMount() {
    axios.get(host + `dashbord/sanaToInList/all`)
      .then(res => {
        let arr = [];
        let totalDevices = 0;
        let pendingCount = 0;

        for (let i = 0; i < res.data.lists.length; i++) {
          totalDevices += res.data.lists[i].item_count;
          if (!res.data.lists[i].is_send) {
            pendingCount++;
          }

          let obj = {
            id: res.data.lists[i].id,
            name: res.data.lists[i].admin,
            count: res.data.lists[i].item_count,
            date: moment(res.data.lists[i].createdAt).tz('Asia/baghdad').format('YYYY/MM/DD'),
            is_send: res.data.lists[i].is_send,
            raw_date: res.data.lists[i].createdAt,
          };

          arr.push(obj);
        }

        this.setState({
          orders: arr,
          filteredOrders: arr,
          spin: false,
          totalLists: res.data.lists.length,
          totalDevices: totalDevices,
          pendingLists: pendingCount,
        });
      })
      .catch(error => {
        console.log(error.response)
      });
  }

  handleSearch = () => {
    const { orders, searchTerm } = this.state;
    
    if (searchTerm.trim() === '') {
      this.setState({ filteredOrders: orders, currentPage: 1 });
      return;
    }

    const filtered = orders.filter(order => 
      order.id.toString().includes(searchTerm) ||
      order.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.date.includes(searchTerm)
    );

    this.setState({ filteredOrders: filtered, currentPage: 1 });
  }

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  }

  render() {
    if (cookies.get("token")) {
      const { filteredOrders, currentPage, itemsPerPage } = this.state;
      
      // Pagination calculations
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
      const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

      return (
        <Context.Consumer>
          {ctx => {
            return (
              <div style={styles.container}>
                {/* Header */}
                <div style={styles.header}>
                  <div style={styles.headerContent}>
                    <h1 style={styles.pageTitle}>
                      <ListAltIcon style={{ fontSize: '2.5rem' }} />
                      قوائم تحويل الأجهزة
                    </h1>
                    
                    <Component initialState={{ isShown: false, isConfirmLoading: false }}>
                      {({ state, setState }) => (
                        <Pane>
                          <Dialog
                            isShown={state.isShown}
                            title='إنشاء قائمة جديدة'
                            onCloseComplete={() => setState({ isShown: false })}
                            confirmLabel="إنشاء القائمة"
                            cancelLabel="إلغاء"
                            isConfirmLoading={this.state.isConfirmLoading}
                            onConfirm={() => {
                              var header = { 
                                "Content-Type": "application/x-www-form-urlencoded", 
                                token: cookies.get("token") 
                              };
                              axios.get(host + `dashbord/sanaToInList/new`, { headers: header })
                                .then(response => {
                                  window.location.href = `/sanalistById?id=${response.data.list.id}`;
                                })
                                .catch(error => { console.log(error) })
                            }}
                          >
                            <div style={{ padding: '1rem' }}>
                              <Alert variant="warning" style={{
                                borderRadius: '8px',
                                border: 'none',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                              }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                  <CategoryIcon style={{ fontSize: '2rem', color: '#f59e0b' }} />
                                  <div>
                                    <strong>تأكيد إنشاء قائمة جديدة</strong>
                                    <p style={{ margin: '0.5rem 0 0' }}>
                                      سيتم إنشاء قائمة جديدة لتحويل أجهزة الصيانة إلى المخزن
                                    </p>
                                  </div>
                                </div>
                              </Alert>
                            </div>
                          </Dialog>
                          
                          <button
                            style={styles.addButton}
                            onClick={() => setState({ isShown: true })}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.15)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
                            }}
                          >
                            <AddCircleOutlineIcon />
                            إنشاء قائمة جديدة
                          </button>
                        </Pane>
                      )}
                    </Component>
                  </div>
                </div>

                {/* Search Box */}
                <div style={styles.searchContainer}>
                  <div style={styles.searchBox}>
                    <input
                      type="text"
                      placeholder="البحث برقم القائمة، اسم المنشئ، أو التاريخ..."
                      style={styles.searchInput}
                      value={this.state.searchTerm}
                      onChange={(e) => this.setState({ searchTerm: e.target.value })}
                      onKeyPress={(e) => e.key === 'Enter' && this.handleSearch()}
                      onFocus={(e) => e.target.style.borderColor = '#667eea'}
                      onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    />
                    <button
                      style={styles.searchButton}
                      onClick={this.handleSearch}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.02)';
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      <SearchIcon />
                      بحث
                    </button>
                  </div>
                </div>

                {/* Statistics Cards */}
                <div style={styles.statsCards}>
                  <div style={{
                    ...styles.statCard,
                    borderRight: '4px solid #667eea',
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '-20px',
                      left: '-20px',
                      width: '100px',
                      height: '100px',
                      background: 'rgba(102, 126, 234, 0.1)',
                      borderRadius: '50%',
                    }} />
                    <div style={{ position: 'relative', zIndex: 1 }}>
                      <ListAltIcon style={{ color: '#667eea', fontSize: '2.5rem', marginBottom: '1rem' }} />
                      <h2 style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#2d3748', margin: '0' }}>
                        {this.state.totalLists}
                      </h2>
                      <p style={{ color: '#718096', fontSize: '1rem', marginTop: '0.5rem' }}>إجمالي القوائم</p>
                    </div>
                  </div>

                  <div style={{
                    ...styles.statCard,
                    borderRight: '4px solid #10b981',
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '-20px',
                      left: '-20px',
                      width: '100px',
                      height: '100px',
                      background: 'rgba(16, 185, 129, 0.1)',
                      borderRadius: '50%',
                    }} />
                    <div style={{ position: 'relative', zIndex: 1 }}>
                      <CategoryIcon style={{ color: '#10b981', fontSize: '2.5rem', marginBottom: '1rem' }} />
                      <h2 style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#2d3748', margin: '0' }}>
                        {this.state.totalDevices}
                      </h2>
                      <p style={{ color: '#718096', fontSize: '1rem', marginTop: '0.5rem' }}>إجمالي الأجهزة</p>
                    </div>
                  </div>

                  <div style={{
                    ...styles.statCard,
                    borderRight: '4px solid #f59e0b',
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '-20px',
                      left: '-20px',
                      width: '100px',
                      height: '100px',
                      background: 'rgba(245, 158, 11, 0.1)',
                      borderRadius: '50%',
                    }} />
                    <div style={{ position: 'relative', zIndex: 1 }}>
                      <SyncDisabledRounded style={{ color: '#f59e0b', fontSize: '2.5rem', marginBottom: '1rem' }} />
                      <h2 style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#2d3748', margin: '0' }}>
                        {this.state.pendingLists}
                      </h2>
                      <p style={{ color: '#718096', fontSize: '1rem', marginTop: '0.5rem' }}>قوائم في المخزن </p>
                    </div>
                  </div>
                </div>

                {/* Modern Table */}
                <div style={styles.tableContainer}>
                  <div style={styles.modernTable}>
                    <div style={styles.tableHeader}>
                      <h3 style={styles.tableTitle}>
                        <ListAltIcon />
                        جدول القوائم
                      </h3>
                      <span style={{ color: '#718096', fontSize: '0.875rem' }}>
                        عرض {indexOfFirstItem + 1} - {Math.min(indexOfLastItem, filteredOrders.length)} من {filteredOrders.length}
                      </span>
                    </div>
                    
                    <table style={styles.table}>
                      <thead style={styles.thead}>
                        <tr>
                                        <th style={{ ...styles.th, width: '120px' }}>رقم القائمة</th>
                          <th style={styles.th}>التاريخ</th>
                          <th style={styles.th}>عدد الأجهزة</th>
                          <th style={styles.th}>منشئ القائمة</th>
       
                               <th style={{ ...styles.th, width: '100px' }}>الإجراءات</th>
                        </tr>
                      </thead>
                      <tbody style={styles.tbody}>
                        {currentItems.length > 0 ? (
                          currentItems.map((order, index) => (
                            <tr
                              key={order.id}
                              style={styles.tr}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f7fafc';
                                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.boxShadow = 'none';
                              }}
                            >


                              <td style={styles.td}>
                                <span style={{
                                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                  color: '#fff',
                                  padding: '0.5rem 1rem',
                                  borderRadius: '20px',
                                  fontWeight: '600',
                                  fontSize: '0.875rem',
                                  display: 'inline-block',
                                }}>
                                  #{order.id}
                                </span>
                              </td>



                              <td style={styles.td}>
                                <span style={{
                                  background: '#e6f7ff',
                                  color: '#1890ff',
                                  padding: '0.25rem 0.75rem',
                                  borderRadius: '6px',
                                  fontSize: '0.875rem',
                                }}>
                                  {order.date}
                                </span>
                              </td>
                              <td style={styles.td}>
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '0.5rem',
                                }}>
                                  <span style={{
                                    background: '#f0f9ff',
                                    color: '#3b82f6',
                                    padding: '0.5rem 1rem',
                                    borderRadius: '8px',
                                    fontWeight: '600',
                                    fontSize: '1rem',
                                  }}>
                                    {order.count}
                                  </span>
                                  <span style={{ color: '#718096', fontSize: '0.875rem' }}>جهاز</span>
                                </div>
                              </td>
                              <td style={styles.td}>
                                <span style={{
                                  fontWeight: '500',
                                  color: '#2d3748',
                                }}>
                                  {order.name}
                                </span>
                              </td>
                                                            <td style={styles.td}>
                                <Link to={`/sanalistById?id=${order.id}`} style={{ textDecoration: 'none' }}>
                                  <button
                                    style={{
                                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                      color: '#fff',
                                      border: 'none',
                                      padding: '0.5rem 1rem',
                                      borderRadius: '8px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '0.5rem',
                                      cursor: 'pointer',
                                      transition: 'all 0.2s ease',
                                      fontSize: '0.875rem',
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.transform = 'scale(1.05)';
                                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.transform = 'scale(1)';
                                      e.currentTarget.style.boxShadow = 'none';
                                    }}
                                  >
                                    <VisibilityIcon style={{ fontSize: '1rem' }} />
                                    عرض
                                  </button>
                                </Link>
                              </td>

                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" style={styles.emptyState}>
                              <div>
                                <ListAltIcon style={{ fontSize: '4rem', color: '#cbd5e0', marginBottom: '1rem' }} />
                                <p style={{ fontSize: '1.125rem', fontWeight: '500', margin: '0' }}>
                                  لا توجد قوائم للعرض
                                </p>
                                <p style={{ fontSize: '0.875rem', marginTop: '0.5rem' }}>
                                  {this.state.searchTerm ? 'جرب البحث بكلمات مختلفة' : 'ابدأ بإنشاء قائمة جديدة'}
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* Pagination */}
                    {totalPages > 1 && (
                      <div style={styles.pagination}>
                        <button
                          style={{
                            ...styles.pageButton,
                            opacity: currentPage === 1 ? 0.5 : 1,
                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                          }}
                          onClick={() => this.handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          <NavigateBeforeIcon style={{ fontSize: '1rem' }} />
                        </button>

                        {[...Array(totalPages)].map((_, index) => (
                          <button
                            key={index + 1}
                            style={{
                              ...styles.pageButton,
                              ...(currentPage === index + 1 ? styles.activePageButton : {})
                            }}
                            onClick={() => this.handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        ))}

                        <button
                          style={{
                            ...styles.pageButton,
                            opacity: currentPage === totalPages ? 0.5 : 1,
                            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                          }}
                          onClick={() => this.handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          <NavigateNextIcon style={{ fontSize: '1rem' }} />
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <ToastContainer
                  position="bottom-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl
                  pauseOnVisibilityChange
                  draggable
                  pauseOnHover
                  style={{ fontFamily: 'Cairo, sans-serif' }}
                />
              </div>
            )
          }}
        </Context.Consumer>
      )
    } else {
      return <Login />
    }
  }
}

export default Category;